var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMessage48Line = function SvgIconMessage48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 37.47a2.64 2.64 0 0 1-1-.21 2.67 2.67 0 0 1-1.65-2.47V15.6a5.08 5.08 0 0 1 5.05-5.07h18.8a5.08 5.08 0 0 1 5.07 5.07v11.61a5.08 5.08 0 0 1-5.07 5.07h-14.8l-4.48 4.42a2.668 2.668 0 0 1-1.92.77Zm2.4-24a2.13 2.13 0 0 0-2.13 2.13v18.54l4.44-4.38a1.46 1.46 0 0 1 1-.43h15.46a2.12 2.12 0 0 0 2.12-2.12V15.6a2.12 2.12 0 0 0-2.12-2.13H14.61Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.74 20.199a1.7 1.7 0 0 0 2.4 2.4 1.7 1.7 0 0 0-2.4-2.4ZM22.8 20.2a1.7 1.7 0 1 0 2.41 2.399A1.7 1.7 0 0 0 22.8 20.2ZM31.27 20.2a1.7 1.7 0 1 0-2.542 2.258A1.7 1.7 0 0 0 31.27 20.2Z",
    fill: "current"
  })));
};
export default SvgIconMessage48Line;